import { render } from "./EmailAction.vue?vue&type=template&id=4cb77ad2&scoped=true"
import script from "./EmailAction.vue?vue&type=script&lang=js"
export * from "./EmailAction.vue?vue&type=script&lang=js"

import "./EmailAction.vue?vue&type=style&index=0&id=4cb77ad2&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.31.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb77ad2"]])

export default __exports__